"use strict";
/*
 * Created on 08. 02. 2019
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Permission_1 = require("../../user/model/Permission");
/**
 * @enum PermissionsSuffixFormat
 */


var PermissionsSuffixFormat;

(function (PermissionsSuffixFormat) {
  PermissionsSuffixFormat["LOWER"] = "LOWER_CASE";
  PermissionsSuffixFormat["UPPER"] = "UPPER_CASE";
})(PermissionsSuffixFormat = exports.PermissionsSuffixFormat || (exports.PermissionsSuffixFormat = {}));
/**
 * Utility method for keycloak permissions usage.
 *
 * @author Tomas Leity
 */


var PermissionsUtils =
/*#__PURE__*/
function () {
  function PermissionsUtils() {
    _classCallCheck(this, PermissionsUtils);
  }

  _createClass(PermissionsUtils, null, [{
    key: "formatSuffix",

    /**
     * Formats suffix by pre-define {@link PermissionsSuffixFormat} format options.
     *
     * @param suffix
     * @param suffixFormat
     * @returns string
     */
    value: function formatSuffix(suffix, suffixFormat) {
      var formatted = suffix;

      switch (suffixFormat) {
        case PermissionsSuffixFormat.LOWER:
          {
            formatted = suffix.toLowerCase();
          }
          break;

        case PermissionsSuffixFormat.UPPER:
          {
            formatted = suffix.toUpperCase();
          }
          break;
      }

      return formatted;
    }
    /**
     * Sets suffix into pre-defined {@link Permission} and creates new {@link Permission}.
     *
     * @param permission
     * @param suffix
     * @param suffixFormat
     * @returns {@link Permission}
     */

  }, {
    key: "withSuffix",
    value: function withSuffix(permission, suffix, suffixFormat) {
      return new Permission_1.Permission(permission.name.replace('<suffix>', suffixFormat ? this.formatSuffix(suffix, suffixFormat) : suffix));
    }
    /**
     * (BULK) Sets suffix into pre-defined {@link Permission} and creates new {@link Permission}.
     *
     * @param permissions Permission sets with suffixes.
     * @returns List of {@link Permission}
     */

  }, {
    key: "withSuffixes",
    value: function withSuffixes(permissions) {
      var _this = this;

      return permissions.map(function (p) {
        return _this.withSuffix(p[0], p[1], p[2]);
      });
    }
  }]);

  return PermissionsUtils;
}();

exports.PermissionsUtils = PermissionsUtils;